module.exports = __webpack_public_path__ + "/images/cover-mujer-joven-embarazada-movil.609a32b.jpg";